import React, { useState, useEffect } from "react";
import { Link, Route, Switch, withRouter } from 'react-router-dom';
import Container from '@material-ui/core/Container';
import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import { Grid } from "@material-ui/core";
import axios from 'axios';
import { API_HOST } from "../../consts";

const Accordion = withStyles({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      marginTop: "10px",
      marginBottom: "10px",
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    display: "flex",
    alignItems: "center",
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #F0F1F2',
    height: "42px",
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    borderRadius: "0 0 4px 4px"
  },
}))(MuiAccordionDetails);

const FaqPage = () => {
  const [expanded, setExpanded] = useState("panel1");
  const [searchFilter, setSearchFilter] = useState('')
  const [faq, setFaq] = useState()

  const fetchFaq = () => {
    axios.get(`${API_HOST}/questionarios/topicos?search=${searchFilter}`)
      .then((response) => {
        setFaq(response.data);
      })
  }

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    fetchFaq();
  }, [searchFilter]);

  return (
    <>
      <Container fixed style={{ border: '1px solid #d6d6d6', backgroundColor: '#ffff', borderRadius: '8px', padding: '2%' }}>

        <h1 style={{
          fontFamily: 'Quicksand',
          fontSize: '22px',
          color: '#292929',
          fontWeight: 'bold'
        }}
        >
          FAQ
        </h1>
        <p
          style={{
            fontSize: '14px',
            fontWeight: '500',
            color: 'rgb(41, 41, 41)'
          }}
        >Perguntas Frequentes</p>
        <Grid style={{ display: 'flex', marginLeft: '82%', marginTop: '-40px' }}>
          <input
            placeholder="Pesquisar..."
            onChange={(e) => setSearchFilter(e.target.value)}
            style={{
              border: "1px solid rgb(190, 190, 190)",
              borderRadius: '8px',
              padding: '3px',
              width: '300px'
            }}
          />
          <i class="fa fa-search" aria-hidden="true"
            style={{
              marginLeft: '10px',
              marginTop: '7px',
              color: 'rgb(154, 154, 154)'
            }}
          />
        </Grid>
        <hr style={{ width: '100%', height: '1px', background: 'rgb(190, 190, 190)' }} />
        <Grid container xs={12} spacing={2}>
          {faq && faq.map((item) => {
            return (
              <Grid direction="column">
                <p
                  style={{ fontSize: '18px', fontWeight: '500', marginTop: '2rem' }}>
                  {item.titulo.toUpperCase()}
                </p>
                {item.subtopico && item.subtopico.map((subItem) => {
                  return (
                    <Grid xs={12}>
                      <Accordion square style={{ display: 'block' }}>
                        <AccordionSummary
                          aria-controls="panel1d-content"
                          id="panel1d-header"
                        >
                          <label style={{ color: "#723DF4", fontFamily: "Quicksand", fontWeight: '600', marginBottom: "2px", fontSize: '15px' }}>
                            {subItem.pergunta}
                          </label>
                        </AccordionSummary>
                        <AccordionDetails style={{ boxShadow: 'none', border: 'none' }} >
                          <span key={subItem.id} style={{ color: "#616161", fontFamily: "Quicksand", fontWeight: '400', marginBottom: "2px", fontSize: '15px' }}>
                            {subItem.resposta}
                          </span>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  )
                })}
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </>
  );
};

export default withRouter(FaqPage);
